import Client, {ClientOption} from '../client';

export default {
  // returns list of all the Insurances route
  getLinkg: (options?: ClientOption) =>
    Client('GET', 'links', undefined, options),
};
